export class DateRange {
  constructor(readonly start: Date, readonly end = new Date()) {}
}
